// extracted by mini-css-extract-plugin
module.exports = {"price":"price-1O91t","meal":"meal-1Po0s","title":"title-2ZTXr"};